import React from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';

interface SectionTitleProps extends Omit<TypographyProps, 'variant'> {
    children: React.ReactNode;
    centered?: boolean;
    variant?: TypographyProps['variant'];
}

const StyledTitle = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'centered',
})<{ centered?: boolean }>(({ theme, centered }) => ({
    position: 'relative',
    paddingBottom: centered ? 0 : theme.spacing(1.5),
    marginBottom: theme.spacing(3),
    fontSize: '1.75rem',
    [theme.breakpoints.up('sm')]: {
        fontSize: '2rem',
    },
    '&::after': centered ? {} : {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '40px',
        height: '3px',
        backgroundColor: theme.palette.orange?.main || '#e67e22',
        borderRadius: '2px',
    },
}));

const SectionTitle: React.FC<SectionTitleProps> = ({ 
    children, 
    centered = false,
    ...props 
}) => {
    return (
        <StyledTitle 
            variant="h2" 
            align={centered ? 'center' : 'left'}
            centered={centered}
            {...props}
        >
            {children}
        </StyledTitle>
    );
};

export default SectionTitle;
